// extracted by mini-css-extract-plugin
export default {"transversalButton":"_3rJPleC46ztEC8-wuJ3yNf"};